import { AppThemeMode } from '@unifyapps/defs/types/interface';

/**
 * Pure structural splitter for cssVars.
 * Light: top-level keys except AppThemeMode.Dark, string values only.
 * Dark: nested object at AppThemeMode.Dark, string values only.
 * Single loop over top-level + single loop over dark object; no extra allocations.
 *
 * For semantic resolution that mirrors legacy single-mode shapes onto both
 * buckets (so opposite-scheme renders never fall back to default.css), use
 * `resolveThemeTokens` instead — it wraps this splitter with scheme-aware rules.
 */
export function extractCssVars(cssVars: Record<string, unknown>): {
  light: Record<string, string>;
  dark: Record<string, string>;
} {
  const light: Record<string, string> = {};
  const dark: Record<string, string> = {};

  for (const [key, value] of Object.entries(cssVars)) {
    if (key === AppThemeMode.Dark) continue;
    if (typeof value === 'string') light[key] = value;
  }

  const darkVarsObj = cssVars[AppThemeMode.Dark];
  if (darkVarsObj && typeof darkVarsObj === 'object' && !Array.isArray(darkVarsObj)) {
    for (const [key, value] of Object.entries(darkVarsObj as Record<string, unknown>)) {
      if (typeof value === 'string') dark[key] = value;
    }
  }

  return { light, dark };
}
